import { useEffect, useState } from "react";
import BriefingTable from "../subcomponents/table";
import { partialsAPI } from "components/Apis/partials";
import { useSelector } from "react-redux";

const ActiveTransitPartials = () => {
    const [transitPartials, setTransitPartials] = useState([]);
    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);


    useEffect(() => {
        (async () => {
            new Promise(resolve => setTimeout(resolve, 500));
            if (briefing === "Briefings") {
                const response = await partialsAPI.getActivePartialsByOrder();
                setTransitPartials(response.data);
            }
            else {
                const response = await partialsAPI.getArchivePartialsByOrder(
                    {
                        start_date: startDate,
                        end_date: endDate,
                        searchTerm: searchTerm,
                    }
                )
                setTransitPartials(response.data);
            }
        })();
    }, [startDate, endDate, searchTerm, briefing]);


    const headers = [
        "Pro #",
        "# of Pieces",
        "Partials",
        "Deliver To",
    ];

    const renderRow = (row) => (
        <>
            <tr className="transit-partials-row" key={row.id}>
                <td style={{ fontWeight: "bold", fontSize: "1.05em" }}>
                    <div className="col">
                        {row.order_no} {row.order_group}
                    </div>
                </td>
                <td>
                    {row.partials[0]?.order.units}
                </td>
                <td className="pt-0">
                    {row.partials && (
                        <tbody className="briefing-subrow">
                            {row.partials.map((partial, index) => (
                                <tr key={index} className={`briefing-partials-subtable ${partial.incoming_completed ? "delivered" : "in-transit"}`}>
                                    <td className="briefing-partials-subtable-frame">
                                        <span className="route">
                                            <td className="text-bold">
                                                {partial.created_at}
                                            </td>
                                            <td className="px-4">
                                                |
                                            </td>
                                            <td className={`warehouse-indicator-pill ${partial.origin_terminal.short_form_name}`}>
                                                {`${partial.origin_terminal.short_form_name}`}
                                            </td>
                                            <td className="px-3">
                                                <i className="fa fa-chevron-right"></i>
                                            </td>
                                            <td className={`warehouse-indicator-pill ${partial.destination_terminal?.short_form_name}`}>
                                                {`${partial.destination_terminal?.short_form_name || "Not Yet Assigned"}`}
                                            </td>
                                            <td className="px-4">
                                                |
                                            </td>
                                            <td style={{ width: '1.8em' }} className="pl-2 text-bold">
                                                {partial.quantity}
                                            </td>
                                            <td className="pl-2 text-bold">
                                                Units
                                            </td>
                                            <td className="px-4">
                                                |
                                            </td>
                                            <td className={`ml-2 warehouse-indicator-pill ${partial.incoming_completed ? "delivered" : "in-transit"}`}>
                                                {partial.incoming_completed ? "Delivered" : "In Transit"}
                                            </td>
                                            <td className="text-bold pl-2">
                                                On {(partial.bus?.driver) ? <>{partial.bus?.driver}</> : <>{partial.bus?.name}</>}
                                            </td>
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </td>
                <td style={{ fontWeight: "bold", fontSize: "1.05em", textAlign: "start" }}>
                    {row.deliver_to}
                </td>
            </tr>
        </>
    );

    // if theres no data in archives hide the section
    if (briefing === "Old Briefings" && !transitPartials.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Transit Partials
                </h2>
            </div>
            <BriefingTable
                headers={headers}
                rows={transitPartials}
                renderRow={renderRow}
            />
        </>
    );
};

export default ActiveTransitPartials;
